import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { TrainerChatsProvider, useTrainerChats } from "../model/TrainerChatsContext";

import styles from "./TrainerChatsLayout.module.scss";

const TrainerChatsLayoutContent = () => {
  const { ensureChats } = useTrainerChats();

  useEffect(() => {
    ensureChats();
  }, [ensureChats]);

  return (
    <div className={styles.page}>
      <div className={styles.inner}>
        <div className={styles.content}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export const TrainerChatsLayout = () => {
  return (
    <TrainerChatsProvider>
      <TrainerChatsLayoutContent />
    </TrainerChatsProvider>
  );
};









